import React from 'react';
import s from './HostStyles.module.scss';
import { PoiHistorySheet } from '../../components';
import entities from './data/cached-sea-pois.json';

const POI1 = entities['66'];
const POI2 = entities['#187'];

const PoiHistoryEditor = () => (
    <div className={s.editor}>
        <PoiHistorySheet pastEntities={[POI1, POI2]} polygonIds={['66b']} />
    </div>
);

export default PoiHistoryEditor;
